import { Navigate, Outlet } from 'react-router-dom';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';
import { useAuth } from '../contexts/AuthContext';
import { getStoredAccessToken } from '../services/apiClient';

export function ProtectedRoute() {
  const { isLoading, profile } = useAuth();

  if (isLoading) {
    return <LoadingSpinner label="Validando sessão..." />;
  }

  if (!getStoredAccessToken() || !profile) {
    return <Navigate to="/login" replace />;
  }

  if (profile.portalOnly) {
    return <Navigate to="/portal" replace />;
  }

  return <Outlet />;
}
